export default "<st-facilities team=\"$ctrl.teamInfo\" user=\"$ctrl.userInfo\" roles=\"$ctrl.roleInfo\" mode=\"$ctrl.mode\"></st-facilities>\n";